"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_directInsertBorrowingBaseReport = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const utils = __importStar(require("../../utils"));
const types_1 = require("./types");
const requiredBorrowingBaseReportLpSlugArtifactFields = {
    loanProductSlug: 'loanProductSlug',
    totalReceivableExposure: 'totalReceivableExposure',
    assetValuation: 'assetValuation',
    totalEligibleExposure: 'totalEligibleExposure',
    totalEligibilityKickout: 'totalEligibilityKickout',
    eligibleExposureLessConcentrationKickouts: 'eligibleExposureLessConcentrationKickouts',
    totalConcentrationKickout: 'totalConcentrationKickout',
    borrowingBaseAmount: 'borrowingBaseAmount',
    performingExposure: 'performingExposure',
};
const requiredEligibilityTestArtifactFields = {
    eligibilityCriteriaKey: 'eligibilityCriteriaKey',
    eligibilityReduction: 'eligibilityReduction',
};
const requiredConcentrationLimitKickoutArtifactFields = {
    concentrationLimitKey: 'concentrationLimitKey',
    concentrationLimit: 'concentrationLimit',
    concentrationAmount: 'concentrationAmount',
    totalEligibleExposure: 'totalEligibleExposure',
    concentration: 'concentration',
    borrowingBaseReduction: 'borrowingBaseReduction',
    // complianceStatus is optional, can be be provided
};
const requiredMultiLoanProductConcentrationKickoutLpSlugArtifactFields = {
    concentrationLimitKey: 'concentrationLimitKey',
    borrowingBaseReduction: 'borrowingBaseReduction',
    loanProductSlug: 'loanProductSlug',
};
const requiredFundingSubmissionComponentsArtifactFields = {
    targetFundingDate: 'targetFundingDate',
    totalAmount: 'totalAmount',
    type: 'type',
};
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Direct Insert Borrowing Base Report`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            creditFacilitySlug: 'CREDIT_FACILITY_SLUG',
            borrowingBaseReportLpSlugArtifactSlug: 'PLACEHOLDER',
            eligibilityTestArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            concentrationLimitKickoutArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            multiLoanProductConcentrationKickoutLpSlugArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            classDetailsArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            fundingSubmissionComponentsArtifactSlug: 'OPTIONAL_PLACEHOLDER',
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = {
            ..._.cloneDeep(nodeToCopy.configuration),
            artifactSlug: utils.updateArtifactSlug(nodeData.configuration.artifactSlug, suggestedSerialNumber),
            borrowingBaseReportLpSlugArtifactSlug: 'PLACEHOLDER',
            eligibilityTestArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            concentrationLimitKickoutArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            multiLoanProductConcentrationKickoutLpSlugArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            classDetailsArtifactSlug: 'OPTIONAL_PLACEHOLDER',
            fundingSubmissionComponentsArtifactSlug: 'OPTIONAL_PLACEHOLDER',
        };
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    return (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: () => true,
        getUINode,
        minInputs: 1,
        maxInputs: 100,
        minOutputs: 0, // for now, this is terminal node
        maxOutputs: 100,
    });
};
// validate given IntermediateRecord.
// this is called after initial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = ({ tape, graph, creditFacilitySlugs, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'directInsertBorrowingBaseReport', `node is not a directInsertBorrowingBaseReport, found: [tape.type:${tape.type}]`);
    const { id, creditFacilitySlug, artifactSlug, configuration } = tape;
    const { borrowingBaseReportLpSlugArtifactSlug, eligibilityTestArtifactSlug, concentrationLimitKickoutArtifactSlug, multiLoanProductConcentrationKickoutLpSlugArtifactSlug, fundingSubmissionComponentsArtifactSlug, classDetailsArtifactSlug, } = configuration;
    const configErrors = [];
    const artifactInputs = utils.getDirectInputsForArtifact({
        targetArtifactId: id,
        ...graph,
    });
    // mutates local configErrors
    const validateFields = ({ artifactSlugToValidate, requiredFields, }) => {
        const artifactInput = artifactInputs.find((input) => input.artifactSlug === artifactSlugToValidate);
        if (!artifactInput) {
            configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] cannot find [inputArtifact:${artifactSlugToValidate}] listed as an input dependency.`);
        }
        else {
            const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactInput.id);
            if (!tapeDefinitionResult.isValid || !tapeDefinitionResult.data) {
                configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] cannot get tape definition of [inputArtifact:${artifactSlugToValidate}].`);
            }
            else {
                const baseFields = tapeDefinitionResult.data.baseFields;
                requiredFields.forEach((field) => {
                    const foundField = baseFields.find((baseField) => baseField.field === field);
                    if (!foundField) {
                        configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] [inputArtifact:${artifactSlugToValidate}] tape definition is missing [field:${field}].`);
                    }
                });
            }
        }
    };
    // check creditFacilitySlug value
    if (!creditFacilitySlugs.includes(creditFacilitySlug)) {
        configErrors.push(`validateIntermediateTape: [${artifactSlug}] has invalid creditFacilitySlug: ${creditFacilitySlug}`);
    }
    validateFields({
        artifactSlugToValidate: borrowingBaseReportLpSlugArtifactSlug,
        requiredFields: Object.keys(requiredBorrowingBaseReportLpSlugArtifactFields),
    });
    if (eligibilityTestArtifactSlug) {
        validateFields({
            artifactSlugToValidate: eligibilityTestArtifactSlug,
            requiredFields: Object.keys(requiredEligibilityTestArtifactFields),
        });
    }
    if (concentrationLimitKickoutArtifactSlug) {
        validateFields({
            artifactSlugToValidate: concentrationLimitKickoutArtifactSlug,
            requiredFields: Object.keys(requiredConcentrationLimitKickoutArtifactFields),
        });
    }
    if (multiLoanProductConcentrationKickoutLpSlugArtifactSlug) {
        validateFields({
            artifactSlugToValidate: multiLoanProductConcentrationKickoutLpSlugArtifactSlug,
            requiredFields: Object.keys(requiredMultiLoanProductConcentrationKickoutLpSlugArtifactFields),
        });
    }
    if (fundingSubmissionComponentsArtifactSlug) {
        validateFields({
            artifactSlugToValidate: fundingSubmissionComponentsArtifactSlug,
            requiredFields: Object.keys(requiredFundingSubmissionComponentsArtifactFields),
        });
    }
    const generatedCashBalanceInputs = artifactInputs.filter((node) => node.type === 'generatedCashBalanceFeed');
    if (generatedCashBalanceInputs.length > 1) {
        configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] cannot have more than 1 generated cash balance feed input but found ${generatedCashBalanceInputs.length}`);
    }
    // all cols are optional, but can still validate the ones provided are valid
    if (classDetailsArtifactSlug) {
        const artifactInput = artifactInputs.find((input) => input.artifactSlug === classDetailsArtifactSlug);
        if (!artifactInput) {
            configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] cannot find [inputArtifact:${classDetailsArtifactSlug}] listed as an input dependency.`);
        }
        else {
            const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactInput.id);
            if (!tapeDefinitionResult.isValid || !tapeDefinitionResult.data) {
                configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] cannot get tape definition of [inputArtifact:${classDetailsArtifactSlug}].`);
            }
            else {
                const baseFields = tapeDefinitionResult.data.baseFields;
                const validFields = new Set(Object.keys(finley_types_1.CreditFacility.ClassLabel));
                baseFields.forEach(({ field }) => {
                    if (!validFields.has(field)) {
                        configErrors.push(`directInsertBorrowingBaseReport: [${artifactSlug}] [inputArtifact:${classDetailsArtifactSlug}] tape definition is has invalid [field:${field}].`);
                    }
                });
            }
        }
    }
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_directInsertBorrowingBaseReport = {
    // what should node say on the tape-builder node creation menu.
    nodeTypeText: 'Direct Insert BBR',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    // operation nodes dont render badges.
    badgeTexts: ['DirectInsert'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map